export function wsUrl(url: string): string {
  const regex = /^https:/;
  if (regex.test(url)) {
    const newUrl = url.replace(/^https:/, 'wss:');
    return newUrl;
  } else {
    return url.replace(/^http:/, 'ws:');
  }
}
